import React from "react";
import {
  Typography,
  Button,
  Dialog,
  TextField,
  AppBar,
  Container,
  Grid,
  Box,
  Card,
  CardContent,
  CardMedia,
  Toolbar,
  useMediaQuery,
  Avatar,
  Link,
  Drawer,
  List,
  ListItem,
  ListItemText,
  IconButton,
  Divider,
} from "@mui/material";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import MenuIcon from "@mui/icons-material/Menu";
import { keyframes } from "@emotion/react";
import Video1 from "../../Videos/video.mp4";
import SkipNextIcon from "@mui/icons-material/SkipNext";
import { Link as RouterLink } from "react-router-dom";
import { styled } from "@mui/material/styles";
import Faq from "./faq";
import Footer from "./footer";
// import NavBar from "./nav";

//Animation
const fadeIn = keyframes`
  0% { opacity: 0; visibility: hidden; }
  100% { opacity: 1; visibility: visible; }
`;

const delay = (index) => ({
  opacity: 0,
  visibility: "hidden",
  animation: `${fadeIn} 1s ease-in-out forwards`,
  animationDelay: `${index * 2}s`,
});

const StyledBox = styled(Box)({
  backgroundImage:
    "url(https://img.freepik.com/premium-photo/online-payment-with-qr-code-concept-virtual-credit-card-smart-phone-office-laptop-desk-clean-marble-table-background-top-view-flat-lay_315337-9601.jpg?w=740)",
  backgroundSize: "cover",
  backgroundPosition: "center",
  minHeight: "80vh",
  padding: "20px",
});

const StyledTypography = styled(Typography)(({ index }) => ({
  marginTop: "15px",
  textAlign: "center",
  fontFamily: "revert-layer",
  color: "#fff",
  textShadow: "2px 2px 14px rgba(0, 0, 0, 0.7)",
  ...delay(index),
}));

const StyledCard = styled(Card)(({ index }) => ({
  border: "2px solid white",
  backgroundColor: "rgba(255, 255, 255, 0.9)",
  boxShadow: "0px 0px 50px grey",
  ...delay(index),
}));

const StyledImage = styled("img")({
  height: "120px",
  width: "120px",
  borderRadius: "100px",
  marginLeft: "120px",
});

class Home extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoggedIn: false,
      openLogin: false,
      openSignup: false,
      drawerOpen: false,
      email: "",
      password: "",
      mobile: "",
      emailError: "",
      mobileError: "",
      passwordError: "",
      name: "",
    };

    this.videoSliderRef = React.createRef();
    this.state = {
      videoUrls1: [Video1], // Video slider 1
      // videoUrls2: [Video2], // Video slider 2
      open: false,
    };
  }

  render() {
    const { isLoggedIn, openLogin, openSignup } = this.state;
    const { drawerOpen } = this.state;
    const { email, password, mobile, emailError } = this.state;
    const { videoUrls1, open } = this.state;
    const { mobileError, passwordError, name } = this.state;
    const { login } = this.props;
    console.log("token", this.props.login.token);
    const sliderSettings = {
      dots: true,
      infinite: false,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      arrows: false,
      autoplaySpeed: 3000,
      pauseOnHover: false,
    };

    const uniqueVideoUrls = [...new Set(videoUrls1)];

    const { width } = this.props;
    const isSmallScreen = width === "xs";
    const isMediumScreen = width === "sm";

    return (
      <div style={{ backgroundColor: "#f4f6f8", minHeight: "100vh" }}>
        <Container maxWidth="xl" style={{ padding: 0 }}>
          {/* <NavBar/> */}

          {/* Video section */}
          <div className="video-banner-container">
            <Slider ref={this.videoSliderRef} {...sliderSettings}>
              <div className="video-slide">
                <video
                  autoPlay
                  muted
                  controls={false}
                  loop
                  width="100%"
                  className="video"
                  // onEnded={() => this.handleVideoEnd(0)}
                >
                  <source src={uniqueVideoUrls[0]} type="video/mp4" />
                </video>
              </div>
            </Slider>
          </div>

          {/* What is QR Code*/}
          <Box sx={{ width: "100%" }}>
            <Grid
              container
              alignItems="center"
              style={{ margin: 0, padding: 0 }}
            >
              <Grid item xs={12}>
                <Card
                  sx={{
                    backgroundColor: "#232F3E",
                    boxShadow: "0px 0px 20px rgba(0,0,0,0.5)",
                    height: { xs: "840px", md: "500px" },
                    width: "100%",
                    margin: 0,
                    padding: 0,
                  }}
                >
                  <CardContent>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: { xs: "column", md: "row" },
                        alignItems: "center",
                        justifyContent: "space-between",
                        gap: "25px",
                        width: "100%",
                      }}
                    >
                      <CardMedia
                        component="img"
                        alt="QR code scanner"
                        src="https://img.freepik.com/free-vector/people-pay-transfer-money-with-mobile-phone_107791-17232.jpg?t=st=1725010309~exp=1725013909~hmac=50a63691cf4ce10d539ca8bb8f38e7964f3e7ea6b33648251b0721df175905cd&w=1060"
                        sx={{
                          height: { xs: "350px", md: "450px" },
                          width: { xs: "100%", md: "100%" },
                          borderRadius: "15px",
                          marginBottom: { xs: "20px", md: "0" },
                        }}
                      />
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "25px",
                          maxWidth: "600px",
                          color: "white",
                          width: "100%",
                        }}
                      >
                        <Typography
                          variant="h3"
                          component="div"
                          sx={{
                            fontFamily: "serif",
                            fontWeight: "bold",
                            fontSize: "35px",
                          }}
                        >
                          What is QR Code?
                        </Typography>
                        <Typography
                          variant="body1"
                          component="div"
                          sx={{
                            fontFamily: "initial",
                            fontSize: "12px",
                            fontFamily: "monospace",
                          }}
                        >
                          QR Code is a two-dimensional version of the barcode,
                          typically made up of black and white pixel patterns.
                          Denso Wave, a Japanese subsidiary of the Toyota
                          supplier Denso, developed them for marking components
                          in order to accelerate logistics processes for their
                          automobile production. Now, it has found its way into
                          mobile marketing with the widespread adoption of
                          smartphones. "QR" stands for "Quick Response", which
                          refers to the instant access to the information hidden
                          in the Code.
                        </Typography>
                        {/* <RouterLink to="/test" style={{ textDecoration: 'none' }}> */}
                        <Button
                          variant="contained"
                          color="secondary"
                          endIcon={<SkipNextIcon />}
                          sx={{
                            width: "300px",
                            alignSelf: { xs: "center", md: "flex-start" },
                          }}
                        >
                          Create Your QR Code
                        </Button>
                        {/* </RouterLink> */}
                      </Box>
                    </Box>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          </Box>

          {/* Animation part*/}
          <StyledBox>
            <StyledTypography variant="h4" index={0}>
              COMMON USES FOR DIGITAL PAYMENT QR CODES
            </StyledTypography>

            <Grid
              container
              spacing={3}
              justifyContent="center"
              sx={{ marginTop: "20px" }}
            >
              <Grid item xs={12} sm={4}>
                <StyledCard index={1}>
                  <CardContent>
                    <StyledImage
                      src="https://img.freepik.com/premium-vector/qr-code-scanning-concept-with-characters_23-2148624246.jpg?w=740"
                      alt="QR Code Scanning"
                    />
                    <Typography variant="h6">
                      1. Allowing diners to pay for a meal by printing a QR Code
                      on receipts
                    </Typography>
                    <Typography variant="body2">
                      Lorem, ipsum dolor sit amet consectetur adipisicing elit.
                      Aspernatur, ex.
                    </Typography>
                  </CardContent>
                </StyledCard>
              </Grid>

              <Grid item xs={12} sm={4}>
                <StyledCard index={2}>
                  <CardContent>
                    <StyledImage
                      src="https://img.freepik.com/free-vector/flat-woman-paying-by-pos-terminal-refund-cashback_88138-785.jpg?w=900&t=st=1724837679~exp=1724838279~hmac=8f2ff3832c43e37dc1c115b412cf186388aa84706b1e28d8b81c80627a519197"
                      alt="Paying by POS Terminal"
                    />
                    <Typography variant="h6">
                      2. Eliminating the need for a point-of-sale system at
                      one-off events
                    </Typography>
                    <Typography variant="body2">
                      Lorem, ipsum dolor sit amet consectetur adipisicing elit.
                      Aspernatur, ex.
                    </Typography>
                  </CardContent>
                </StyledCard>
              </Grid>

              <Grid item xs={12} sm={4}>
                <StyledCard index={3}>
                  <CardContent>
                    <StyledImage
                      src="https://img.freepik.com/free-vector/qr-code-scanning-concept-with-characters_23-2148616357.jpg?t=st=1724837854~exp=1724841454~hmac=87f944180ec276eec12a10051713ae7558300d950ff34241515e6292e19bb730&w=740"
                      alt="QR Code Scanning Concept"
                    />
                    <Typography variant="h6">
                      3. Encouraging sales by offering exclusive discounts
                    </Typography>
                    <Typography variant="body2">
                      Lorem, ipsum dolor sit amet consectetur adipisicing elit.
                      Aspernatur, ex.
                    </Typography>
                  </CardContent>
                </StyledCard>
              </Grid>
            </Grid>
          </StyledBox>

          {/* Create Qr code Culture */}
          <Box
            sx={{
              position: "relative",
              minHeight: "90vh",
              padding: isSmallScreen ? "10px" : "20px",
              backgroundImage:
                "url(https://qrlab.com/blog/storage/thumbnails/IxIl83bDRZUlYBUfUOOOt3v4AC4Cr9hFjLRYU2vl.webp)",
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
              overflow: "hidden",
              "&::before": {
                content: '""',
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundImage:
                  "url(https://qrlab.com/blog/storage/thumbnails/2BWyOcb6aTmXLJppktQtpKq0ewqVhXR477wEjSUn.webp)",
                backgroundSize: "cover",
                backgroundPosition: "center",
                filter: "blur(15px)",
                zIndex: 1,
                pointerEvents: "none",
              },
              "& > div": {
                position: "relative",
                zIndex: 2,
                fontFamily: "fantasy",
                fontSize: isSmallScreen
                  ? "2.5rem"
                  : isMediumScreen
                  ? "4rem"
                  : "5rem",
                marginTop: isSmallScreen ? "80px" : "120px",
                marginLeft: isSmallScreen
                  ? "20px"
                  : isMediumScreen
                  ? "60px"
                  : "100px",
                fontWeight: "bolder",
                display: "flex",
                flexDirection: "column",
                alignItems: isSmallScreen ? "center" : "start",
                color: "azure",
                gap: "15px",
                textAlign: isSmallScreen ? "center" : "left",
              },
            }}
          >
            <div width={isSmallScreen ? "90%" : "800px"}>
              <Typography
                variant="h4"
                width={isSmallScreen ? "100%" : "650px"}
                fontSize={isSmallScreen ? "24px" : "38px"}
              >
                <b>QR Codes for Culture:</b>
                <b>
                  <i> Comprehensive free Package of Design Services</i>
                </b>
              </Typography>
              <Typography
                variant="body1"
                fontSize={isSmallScreen ? "16px" : "20px"}
                width={isSmallScreen ? "100%" : "650px"}
              >
                <b>
                  Get Custom QR Codes and Description Pages Created by ME-QR
                  Professional Team.
                </b>
              </Typography>
              <Button
                variant="contained"
                sx={{ alignSelf: isSmallScreen ? "center" : "start" }}
              >
                Get Started
              </Button>
            </div>
          </Box>

          {/* images of qr */}
          <Box
            sx={{
              padding: 0,
              minHeight: "400px",
            }}
          >
            <img
              src="https://bankbuddy.ai/img/posts_img/QR-CODE-blog.png"
              style={{ height: "495px", width: "100%" }}
              alt="QR Code Example"
            />
          </Box>

          {/* QR in 3 steps */}
          <Box minHeight="80vh" padding="20px">
            <Typography
              variant="h4"
              index={0}
              marginTop="15px"
              textAlign="center"
              fontFamily="revert-layer"
              color="#000"
              textShadow="2px 2px 14px rgba(0, 0, 0, 0.7)"
            >
              Create QR Code in 3 Steps
            </Typography>

            <Grid
              container
              spacing={3}
              justifyContent="center"
              sx={{ marginTop: "20px" }}
            >
              <Grid item xs={12} sm={4}>
                <Card index={1}>
                  <CardContent>
                    <img
                      src="https://me-qr.com/static/pages/main-page-img/step-1.svg"
                      alt="step1"
                    />
                    <Typography
                      variant="h6"
                      color="purple"
                      textAlign="center"
                      backgroundColor="#F5E9F7"
                      width="120px"
                    >
                      STEP 1:
                    </Typography>
                    <Typography
                      variant="h4"
                      color="grey"
                      textAlign="center"
                      marginTop="20px"
                    >
                      Choose The Type
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>

              <Grid item xs={12} sm={4}>
                <Card index={1}>
                  <CardContent>
                    <img
                      src="https://me-qr.com/static/pages/main-page-img/step-2.svg"
                      alt="step2"
                    />
                    <Typography
                      variant="h6"
                      color="purple"
                      textAlign="center"
                      backgroundColor="#F5E9F7"
                      width="120px"
                    >
                      STEP 2:
                    </Typography>
                    <Typography
                      variant="h4"
                      color="grey"
                      textAlign="center"
                      marginTop="20px"
                    >
                      Generate QR Code
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>

              <Grid item xs={12} sm={4}>
                <Card index={1}>
                  <CardContent>
                    <img
                      src="https://me-qr.com/static/pages/main-page-img/step-3.svg"
                      alt="step3"
                    />
                    <Typography
                      variant="h6"
                      color="purple"
                      textAlign="center"
                      backgroundColor="#F5E9F7"
                      width="120px"
                    >
                      STEP 3:
                    </Typography>
                    <Typography
                      variant="h4"
                      color="grey"
                      textAlign="center"
                      marginTop="20px"
                    >
                      Customize & Download
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          </Box>

          {/* Companies list */}
          <Card
            sx={{
              minHeight: "50vh",
              padding: "20px",
              backgroundColor: "#F5F5F5",
              maxWidth: "100%",
              boxShadow: 3,
              borderRadius: 2,
            }}
          >
            <CardContent>
              <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                  <Typography variant="h3" color="#3E4957">
                    Trusted by Your Favorite Companies
                  </Typography>
                  <Typography
                    variant="body1"
                    color="#8B929A"
                    marginTop="30px"
                    style={{ fontSize: "19px" }}
                    fontWeight="medium"
                  >
                    Trusted by more than <b>100+</b> companies and{" "}
                    <b>900,000+</b> customers all over the world
                  </Typography>
                </Grid>

                {/* Image Section */}
                <Grid item xs={12} md={6}>
                  <Grid container spacing={3}>
                    <Grid item xs={4} sm={4} md={4}>
                      <img
                        src="https://me-qr.com/static/pages/main-page-img/disney-logo.svg"
                        height="100px"
                        width="100px"
                        alt="Disney Logo"
                      />
                    </Grid>
                    <Grid item xs={4} sm={4} md={4}>
                      <img
                        src="https://me-qr.com/static/pages/main-page-img/amazon-logo.svg"
                        height="100px"
                        width="100px"
                        alt="Amazon Logo"
                      />
                    </Grid>
                    <Grid item xs={4} sm={4} md={4}>
                      <img
                        src="https://me-qr.com/static/pages/main-page-img/starbucks-logo.svg"
                        height="100px"
                        width="100px"
                        alt="Starbucks Logo"
                      />
                    </Grid>
                    <Grid item xs={4} sm={4} md={4}>
                      <img
                        src="https://me-qr.com/static/pages/main-page-img/ups-logo.svg"
                        height="100px"
                        width="100px"
                        alt="UPS Logo"
                      />
                    </Grid>
                    <Grid item xs={4} sm={4} md={4}>
                      <img
                        src="https://me-qr.com/static/pages/main-page-img/walmart-logo.svg"
                        height="100px"
                        width="100px"
                        alt="Walmart Logo"
                      />
                    </Grid>
                    <Grid item xs={4} sm={4} md={4}>
                      <img
                        src="https://me-qr.com/static/pages/main-page-img/honeywell-logo.svg"
                        height="100px"
                        width="100px"
                        alt="Honeywell Logo"
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </CardContent>
          </Card>

          {/* FAQs */}
          <div
            style={{ padding: "20px", textAlign: "center", marginTop: "50px" }}
          >
            <Typography variant="h4" gutterBottom>
              Frequently Asked Questions
            </Typography>
            <Grid container spacing={4} justifyContent="center">
              <Grid item xs={12} md={6}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "20px",
                  }}
                >
                  <Card sx={{ padding: "20px" }}>
                    <CardContent>
                      <Typography
                        gutterBottom
                        sx={{
                          fontSize: 24,
                          fontFamily: "sans-serif",
                          fontWeight: "bold",
                          color: "#8D85F1",
                        }}
                      >
                        Question 1: Is QR Code free?
                      </Typography>
                      <Divider />
                      <br />
                      <Typography
                        variant="body2"
                        color="grey"
                        textAlign="justify"
                      >
                        <b>ans:</b> &nbsp; Service absolutely free, but after a
                        scan, we will show advertisements (Google Ads). To
                        remove advertisements and get more statistics, you can
                        buy our premium account.
                      </Typography>
                    </CardContent>
                  </Card>
                  <Card sx={{ padding: "20px" }}>
                    <CardContent>
                      <Typography
                        gutterBottom
                        sx={{
                          fontSize: 24,
                          fontFamily: "sans-serif",
                          fontWeight: "bold",
                          color: "#8D85F1",
                        }}
                      >
                        Question 2: What kind of information can be stored in QR
                        Code?
                      </Typography>
                      <Divider />
                      <br />
                      <Typography
                        variant="body2"
                        color="grey"
                        textAlign="justify"
                      >
                        <b>ans:</b> &nbsp; QR Codes are so versatile, they are
                        able to store a variety of information depending on your
                        needs. It can store a URL to make it easier for you to
                        open a page on the web with just a scan. It can also
                        store contact details so that you don’t have to manually
                        type the name, phone number, and email address to save
                        it to your phone.
                      </Typography>
                    </CardContent>
                  </Card>
                </div>
              </Grid>
              <Grid
                item
                xs={12}
                md={6}
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <img
                  src="https://img.freepik.com/free-vector/pay-by-smart-phone-wallet-transaction-sending-digital-money-money-transferring-digitally-from-one-mobile-phone-another-vector-flat-illustration_1150-58768.jpg"
                  alt="FAQ Illustration"
                  style={{ maxWidth: "100%", height: "auto" }}
                />
              </Grid>
            </Grid>
          </div>

          {/* News */}
          <Box minHeight="80vh" padding="20px">
            <Typography
              variant="h4"
              index={0}
              marginTop="15px"
              textAlign="center"
              fontFamily="revert-layer"
              color="#000"
              textShadow="2px 2px 14px rgba(0, 0, 0, 0.7)"
            >
              NEWS
            </Typography>

            <Grid
              container
              spacing={3}
              justifyContent="center"
              sx={{ marginTop: "20px", alignItems: "center" }}
            >
              <Grid item xs={12} sm={4}>
                <Card index={1}>
                  <CardContent>
                    <img
                      src="https://cdn.me-qr.com/front/static_preview/66cf1595f081c5.62529558.png"
                      alt="step1"
                      height="200px"
                      width="350px"
                    />
                    <Typography variant="h6" fontSize="30px">
                      Are QR Codes Safe: How to Avoid QR Code Fake?
                    </Typography>
                    <Typography
                      variant="body1"
                      color="grey"
                      textAlign="center"
                      marginTop="16px"
                    >
                      QR codes are ubiquitous these days, seamlessly bridging
                      the gap between the phys ...
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>

              <Grid item xs={12} sm={4}>
                <Card index={1}>
                  <CardContent>
                    <img
                      src="https://cdn.me-qr.com/front/static_preview/66cefb3be33f66.46262138.png"
                      alt="step1"
                      height="200px"
                      width="350px"
                    />
                    <Typography variant="h6" fontSize="30px">
                      Who Invented the QR Code: the History of QR Codes ...
                    </Typography>
                    <Typography
                      variant="body1"
                      color="grey"
                      textAlign="center"
                      marginTop="16px"
                    >
                      QR codes stand as ubiquitous symbols of convenience,
                      linking physical objects to ...
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>

              <Grid item xs={12} sm={4}>
                <Card index={1}>
                  <CardContent>
                    <img
                      src="https://cdn.me-qr.com/front/static_preview/66cdabf754fe84.40729565.png"
                      alt="step1"
                      height="200px"
                      width="350px"
                    />
                    <Typography variant="h6" fontSize="30px">
                      QR-Code for car
                    </Typography>
                    <Typography
                      variant="body1"
                      color="grey"
                      textAlign="center"
                      marginTop="10px"
                    >
                      Although QR Codes were designed to track automotive
                      manufacturing parts, like Cadillac, GM Motors, and
                      Mercedes have adopted QR Codes for more than just
                      tracking....
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          </Box>

          <Footer />
        </Container>
      </div>
    );
  }
}

export default Home;
